__turbopack_context__.v({
  "backdrop": "HG51wq_backdrop",
  "backdropFullHeightMobile": "HG51wq_backdropFullHeightMobile",
  "closeTrigger": "HG51wq_closeTrigger",
  "dialog": "HG51wq_dialog",
  "mobileFitContent": "HG51wq_mobileFitContent",
  "mobileFullWidth": "HG51wq_mobileFullWidth",
  "mobileFullscreen": "HG51wq_mobileFullscreen",
  "mobilePositionBottom": "HG51wq_mobilePositionBottom",
  "modalBody": "HG51wq_modalBody",
  "modalHeader": "HG51wq_modalHeader",
  "normalDialog": "HG51wq_normalDialog",
  "scrollWrapper": "HG51wq_scrollWrapper",
});
